var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"clear-button tooltip is-tooltip-left",attrs:{"data-tooltip":"Clear Queue"},on:{"click":function($event){$event.preventDefault();return _vm.clearQueue.apply(null, arguments)}}},[_c('IconTrash')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }